import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import facebook from "../assets/images/facebook-f.webp";
import telegram from "../assets/images/telegram-f.webp";
import support from "../assets/images/support-f.webp";
import whatsapp from "../assets/images/whatsapp-f.webp";
import { isEmpty } from "lodash";
import Modal from "react-bootstrap/Modal";
import Slider from "react-slick";
import { BannerSliderData } from "../Utils/constants";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
const Footer = () => {
  function PrevArrow(props) {
    const { onClick } = props;
    return (
      <div className="popup-nav-left" onClick={onClick}>
        <FaChevronLeft />
        <span>Previous</span>
      </div>
    );
  }

  function NextArrow(props) {
    const { onClick } = props;
    return (
      <div className="popup-nav-right" onClick={onClick}>
        <span>Next</span>
        <FaChevronRight />
      </div>
    );
  }

  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />, // ✅ fixed spelling
    nextArrow: <NextArrow />,
  };

  const location = useLocation();
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const showSidebar = useContextSelector(AuthContext, (ctx) => ctx.showSidebar);
  const active = useContextSelector(AuthContext, (ctx) => ctx.active);
  const setFooterLink = useContextSelector(
    AuthContext,
    (ctx) => ctx.setFooterLink,
  );
  const displayPopUp = useContextSelector(
    AuthContext,
    (ctx) => ctx.displayPopUp,
  );
  const setDisplayPopUp = useContextSelector(
    AuthContext,
    (ctx) => ctx.setDisplayPopUp,
  );
  const navigate = useNavigate();
  const [casinoModel, setCasinoModel] = useState(false);
  const [startX, setStartX] = useState(null);
  const [startY, setStartY] = useState(null);
  const [icon, setIcon] = useState({});
  const handleTouchStart = (event) => {
    const touch = event.touches[0];
    setStartX(touch.clientX);
    setStartY(touch.clientY);
  };

  const getData = async () => {
    let hostname = window.location.hostname;
    hostname = hostname.replace(/^www\./, "");
    hostname = hostname.replace(/^ag\./, "");
    const { data } = await apiGet(apiPath?.getIcon, {
      website: "ck75.live",
      user_id: user ? user?.user?._id : "",
    });
    if (data?.success) {
      setIcon(data?.results);
    }
  };
  useEffect(() => {
    getData();
  }, []);

  const handleTouchEnd = (event) => {
    const touch = event.changedTouches[0];
    const endX = touch.clientX;
    const endY = touch.clientY;
    const distance = Math.sqrt((endX - startX) ** 2 + (endY - startY) ** 2);
    if (distance < 5) {
      setCasinoModel(true);
    }
  };
  const [showf, setshowf] = useState(false);

  const closePopUp = () => {
    localStorage.setItem("seenPopUp", true);

    setDisplayPopUp(false);
  };

  useEffect(() => {
    let returningUser = localStorage.getItem("seenPopUp");

    setDisplayPopUp(!returningUser);
  }, []);
  // console.log(location.pathname);
  return (
    <>
      {!['/casino','/deposit'].includes(location.pathname) ? (
        <div class="float-service">
          <div class="service-list">
            <div
              class="service-item"
              onClick={() => {
                window.open(
                  icon?.whatsappContent
                    ? "https://wa.me/" + icon?.whatsappContent
                    : "https://wa.me/+",
                  "_self",
                );
              }}
            >
              <img class="service-icon" src={whatsapp} />
            </div>
            <div
              class="service-item"
              onClick={() => {
                window.open("https://www.facebook.com/", "_self");
              }}
            >
              <img class="service-icon" src={facebook} />
            </div>
            <div
              class="service-item"
              onClick={() => {
                window.open(
                  icon?.telegramContent
                    ? icon?.telegramContent
                    : "https://t.me/",
                  "_self",
                );
              }}
            >
              <img class="service-icon" src={telegram} />
            </div>
            <div
              class="service-item"
              onClick={() => {
                window.open(
                  "#",
                );
              }}
            >
              <img class="service-icon" src={support} />
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      {/* {displayPopUp && (
        <Modal
          centered
          show={true}
          onHide={closePopUp}
          className="anouncement-popup"
        >
          <Modal.Header
            closeButton
            className="mobile-singup-bonus-header"
          ></Modal.Header>
          <header class="popup_main_header">
            <div class="shell-popup-header">
              <span>Announcement</span>
            </div>
          </header>
          <Modal.Body className="mobile-singup-bonus">
            <Slider {...settings}>
              {BannerSliderData?.length > 0 &&
                BannerSliderData?.map((item) => {
                  return (
                    <div className="slider-items-banner">
                      <figure className="mb-0">
                        <img
                          
                          src={item?.bannerImg}
                          alt=""
                        />
                      </figure>
                    </div>
                  );
                })}
            </Slider>
          </Modal.Body>

          
        </Modal>
      )} */}
    </>
  );
};

export default Footer;
